var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBespoke(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3752 7.87565C18.1462 8.10931 18.0179 8.42346 18.0179 8.75065C18.0179 9.07784 18.1462 9.39199 18.3752 9.62565L20.3752 11.6256C20.6088 11.8547 20.923 11.983 21.2502 11.983C21.5774 11.983 21.8915 11.8547 22.1252 11.6256L26.8377 6.91315C27.4662 8.30213 27.6565 9.84969 27.3833 11.3496C27.11 12.8495 26.3861 14.2305 25.308 15.3085C24.23 16.3865 22.849 17.1104 21.3491 17.3837C19.8492 17.657 18.3017 17.4667 16.9127 16.8381L8.27519 25.4756C7.7779 25.9729 7.10345 26.2523 6.40019 26.2523C5.69692 26.2523 5.02247 25.9729 4.52519 25.4756C4.0279 24.9784 3.74854 24.3039 3.74854 23.6006C3.74854 22.8974 4.0279 22.2229 4.52519 21.7256L13.1627 13.0881C12.5341 11.6992 12.3438 10.1516 12.6171 8.65171C12.8904 7.15183 13.6143 5.77084 14.6923 4.6928C15.7704 3.61476 17.1514 2.89086 18.6513 2.61757C20.1511 2.34429 21.6987 2.5346 23.0877 3.16315L18.3877 7.86315L18.3752 7.87565Z",
    stroke: "#183171",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBespoke);
export default __webpack_public_path__ + "static/media/bespoke.3485944562f78047dabf24fee33f3784.svg";
export { ForwardRef as ReactComponent };